export const framesToSamples = (frames, windowSize, osamp) => {
  const hopSize = windowSize / osamp;
  return (frames + 1) * hopSize;
};